import React, { useEffect, useState } from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';

import { Icon } from '../uiold';
import { themeColors } from '../uiold/Constants';
import { useBuilderState } from './BuilderContext';
import createFormElement from './FormElements/createFormElement';
import createTextComponent from '../../support/rn-web/createTextComponent';

import {
  EvaluationFormDefinition,
  FormElementType,
} from '../../types/shared/EvaluationForm';

const Text = createTextComponent({
  tagName: 'div',
  additionalProps: {
    title: true,
  },
});

function addQuestion(
  draft: EvaluationFormDefinition,
  addAfterIndex = 0,
  type: FormElementType = 'TextInputElement',
) {
  let field = createFormElement(type);
  let activeFieldIndex = addAfterIndex + 1;
  draft.fields.splice(addAfterIndex + 1, 0, field);
  return { activeFieldId: field.id, activeFieldIndex };
}

function BuilderMenu() {
  let {
    activeFieldId,
    activeFieldIndex,
    update,
    setActiveField,
  } = useBuilderState();
  let [top, setTop] = useState(0);

  useEffect(() => {
    // TODO: Update offset with scroll position.
    if (activeFieldId) {
      let field = document.getElementById(activeFieldId);
      if (field) {
        let { top } = field.getBoundingClientRect();
        setTop(Math.max(top - 185, 0));
      }
    }
  }, [activeFieldId]);

  return (
    <View style={[styles.root, { top }]}>
      <TouchableOpacity
        onPress={() =>
          update((
            draft, // Add new field and set is as active.
          ) => setActiveField(addQuestion(draft, activeFieldIndex || 0)))
        }
      >
        {/* Text is used to add "title" attribute */}
        <Text title={t('Add question')}>
          <Icon name="plusCircle" size="M" />
        </Text>
      </TouchableOpacity>
    </View>
  );
}

let styles = StyleSheet.create({
  root: {
    position: 'absolute',
    left: 768 + 8,
    width: 48,
    alignItems: 'center',
    backgroundColor: themeColors.white,
    paddingVertical: 12,
    borderColor: themeColors.borderGrey,
    borderRadius: 5,
    borderWidth: 1,
  },
});

export default BuilderMenu;
